import React from 'react';
import { trackQuantityChange } from '../utils/analytics';
import './QuantitySelector.css';

function QuantitySelector({ quantity, setQuantity }) {
  const handleDecrease = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const handleIncrease = () => {
    if (quantity < 48) {
      setQuantity(quantity + 1);
    }
  };

  const handleChange = (e) => {
    let newValue = parseInt(e.target.value);
    if (isNaN(newValue)) newValue = 1;
    if (newValue < 1) newValue = 1;
    if (newValue > 48) newValue = 48;
    
    // Track quantity change in analytics
    if (newValue !== quantity) {
      trackQuantityChange(newValue);
    }
    
    setQuantity(newValue);
  };

  return (
    <section className="quantity-selector">
      <h2>How many pavs would you like to make?</h2>
      <div className="quantity-controls">
        <button onClick={handleDecrease} aria-label="Decrease quantity">-</button>
        <input 
          type="number" 
          value={quantity}
          onChange={handleChange}
          min="1" 
          max="48"
          aria-label="Quantity"
        />
        <button onClick={handleIncrease} aria-label="Increase quantity">+</button>
      </div>
    </section>
  );
}

export default QuantitySelector;